import { File, FileDown } from 'lucide-react'
import type { FileUIPart } from 'ai'

export function Attachments({ files }: { files: FileUIPart[] }) {
  if (!files.length) return null
  return <div className="flex flex-wrap gap-2">{files.map((file, index) => <a key={`${file.url}-${index}`} href={file.url} target="_blank" rel="noreferrer" className="flex max-w-full items-center gap-2 rounded-xl border border-panel-border/70 bg-panel-raised px-3 py-2 text-xs text-ink-muted hover:text-ink"><File className="h-3.5 w-3.5 shrink-0" /><span className="max-w-48 truncate">{file.filename || 'Attachment'}</span><FileDown className="h-3.5 w-3.5 shrink-0 text-ink-faint" /></a>)}</div>
}
